import DefaultEditElement from '../EditInputFields/DefaultEditElement.js'
import { useUiFromSpecContext } from '../../../EditorContextProvider.js'
import { useMemo } from 'react'
import { UseFormReturn } from 'react-hook-form'

export default function GeneralEditElement({
  form,
  currentElementState,
  setCurrentElementState,
}: {
  form: UseFormReturn<any>
  currentElementState: any
  setCurrentElementState: React.Dispatch<any>
}) {
  const { customEditElement } = useUiFromSpecContext()
  const generalCurrentElementState = useMemo(() => {
    if (!currentElementState) return null
    const { logic, constraints, ...rest } = currentElementState
    return rest
  }, [currentElementState])

  return (
    <>
      {generalCurrentElementState &&
        Object.keys(generalCurrentElementState).map((element, index) => {
          if (customEditElement) {
            return customEditElement({
              element,
              index,
              currentElementState,
              setCurrentElementState,
              defaultEditElementProps: (
                <DefaultEditElement
                  key={index}
                  index={index}
                  form={form}
                  element={element}
                  currentElementState={currentElementState}
                  setCurrentElementState={setCurrentElementState}
                />
              ),
            })
          }

          return (
            <DefaultEditElement
              key={index}
              index={index}
              form={form}
              element={element}
              currentElementState={currentElementState}
              setCurrentElementState={setCurrentElementState}
            />
          )
        })}
    </>
  )
}
